export const PROJECT_ANALYSIS_PAGE_TITLE = 'Project analysis'
